import { PeriscopePardotPicklistValue } from '@sonar-software/sonar-ts-types';
import React from 'react';
import { SonarRecord } from '@ui/records';

export interface PicklistValueProps {
	picklistValue: PeriscopePardotPicklistValue;
}

export const PardotPicklistValue: React.FC<PicklistValueProps> = ({ picklistValue }) =>
	<SonarRecord
		name={ picklistValue.displayName }
		secondaryInfo={ picklistValue.internalName }
		sonarObjectId={ null } />;

